// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"3926431d","120":"314f0ff4","749":"4ad73fb6","995":"e795d089"}[chunkId] + ".js";
};